import '../src/jizura/register'
import { mountBridgeApp } from './bridgeHost'

const el = document.getElementById('root')
if (!el) {
  throw new Error('lyric-stage: #root missing')
}
mountBridgeApp(el)
